import React from 'react'

import FormValidationErrorMessage from '@zet/customer/src/components/formValidationErrorMessage'
import { B1, B2, Input, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { subYears } from 'date-fns'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Control, Controller, FieldErrors } from 'react-hook-form'

import { DateField } from './dateField'

const FormFields = ({
  control,
  errors,
}: {
  control: Control<{ panNumber: string; dob: Date }, any>
  errors: FieldErrors<{ panNumber: string; dob: Date }>
}) => {
  return (
    <Stack className="px-3">
      <B2 className="text-grays-80 mb-1 mt-3">
        {i18n.t('webFlow.basicDetails.pan')}{' '}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>
      <Controller
        control={control}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { isTouched },
        }) => (
          <Input
            maxLength={10}
            placeholder="Eg: BHWIC2448S"
            onBlur={onBlur}
            onChangeText={onChange}
            value={value}
            type={
              Boolean(errors?.panNumber?.message) && isTouched
                ? 'error'
                : errors?.panNumber?.message ===
                  i18n.t('webFlow.basicDetails.panExist')
                ? 'warning'
                : 'primary'
            }
          />
        )}
        name="panNumber"
      />
      <FormValidationErrorMessage
        error={errors?.panNumber?.message}
        key={errors?.panNumber?.message}
      />
      <B2 className="text-grays-80 mb-1 mt-4">
        {i18n.t('webFlow.basicDetails.dob')}
        <B1 className="text-error-100 ml-1">*</B1>
      </B2>
      <Controller
        control={control}
        name="dob"
        render={({ field: { value, onChange } }) => (
          <>
            <DatePicker
              selected={value}
              onChange={(date) => {
                onChange(date)
              }}
              customInput={<DateField />}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              maxDate={subYears(new Date(), 15)}
              popperPlacement="top"
              popperProps={{
                strategy: 'fixed',
              }}
            />
          </>
        )}
      />
    </Stack>
  )
}

export { FormFields }
